(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/fractiongames/assets/javascript/constants.js') >= 0) return;  svs.modules.push('/modules/fractiongames/assets/javascript/constants.js');
"use strict";


const NAV_ITEMS = [{
  productName: 'Lotto',
  to: '/lotto',
  backgroundClass: 'bg-lotto'
}, {
  productName: 'Eurojackpot',
  to: '/eurojackpot',
  backgroundClass: 'bg-eurojackpot'
}, {
  productName: 'Keno',
  to: '/keno',
  backgroundClass: 'bg-keno'
}, {
  productName: 'Vikinglotto',
  to: '/vikinglotto',
  backgroundClass: 'bg-vikinglotto-100'
}];
svs.fractiongames.constants = {
  INDEX_ROUTE: '/',
  GAMES_ROUTE: '/:productParam(lotto|keno|vikinglotto|eurojackpot)?',
  NAV_ITEMS
};

 })(window);